import ChartingHighchartsBaseController from './charting_highcharts_base_controller';

export default class extends ChartingHighchartsBaseController {
  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  tooltipFormatter(ctx) {
    const p = ctx.point;

    if (p.fromNode && p.toNode) {
      let html = `<b>${p.fromNode.name} → ${p.toNode.name}</b>`;

      if (p.weight != null) html += `<br/>${p.weight}`;

      return html;
    }

    return `<b>${p.name}</b>`;
  }

  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  resolveClickValue(point, _member) {
    return point.name || point.id;
  }
}
